var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2083_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6318 6.01875C21.5204 5.57382 21.2936 5.16616 20.9743 4.83694C20.6549 4.50773 20.2544 4.26861 19.813 4.14375C18.2005 3.75 11.7505 3.75 11.7505 3.75C11.7505 3.75 5.30054 3.75 3.68804 4.18125C3.24671 4.30611 2.84614 4.54523 2.5268 4.87444C2.20746 5.20366 1.98065 5.61132 1.86929 6.05625C1.57417 7.69271 1.42982 9.35279 1.43804 11.0156C1.42752 12.691 1.57188 14.3637 1.86929 16.0125C1.99206 16.4436 2.22395 16.8358 2.54255 17.1511C2.86114 17.4664 3.25568 17.6942 3.68804 17.8125C5.30054 18.2438 11.7505 18.2438 11.7505 18.2438C11.7505 18.2438 18.2005 18.2438 19.813 17.8125C20.2544 17.6876 20.6549 17.4485 20.9743 17.1193C21.2936 16.7901 21.5204 16.3824 21.6318 15.9375C21.9246 14.3134 22.069 12.6659 22.063 11.0156C22.0736 9.34027 21.9292 7.66753 21.6318 6.01875Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64062 14.0814L15.0312 11.0158L9.64062 7.9502V14.0814Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2083_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.642d8b159cc5487632f9222a9a0b5e57.svg";
export { ForwardRef as ReactComponent };